export const ApiSettingsWidgets = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/widgets/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/widgets/${id}`)
    return result.data
  }

  const remove = async (id) => {
    const result = await axios.delete(`/api/settings/widgets/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/widgets')
    return result.data
  }

  return {
    widgetsFind: find,
    widgetsLoad: load,
    widgetsRemove: remove,
    widgetsSave: save
  }
}
